import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyDashboardsConfigureRoute: InvariantJiraRoute = {
	name: 'legacy-dashboards-configure',
	path: '(/secure/|/)ConfigurePortalPages([!%]?[\\w]*).jspa',
};
